import { deepLinkStore } from "@/store/pinia_modules/deepLinkStore";
import { CategoryType } from "./category";

export enum GameMechanicType {
    TAP_TO_PLAY = "tap-to-play",
    CUSTOM_GAME = "custom-game",
}

export enum ShareStatus {
    SHARED = "shared",
    PENDING = "pending",
    NOT_SHARED = "not-shared",
}

export enum PrizeStatus {
    ALLOCATED = "allocated",
    UNALLOCATED = "unallocated",
    REDEEMED = "redeemed",
    EXPIRED = "expired",
}

export enum ClaimErrorStatus {
    NOT_FOUND_ERROR = "NOT_FOUND_ERROR",
    MAX_ITEMS_CLAIMED = "MAX-ITEMS-CLAIMED",
    VOUCHER_FAILED = "VoucherFailed",
    VOUCHER_USER_LIMIT = "VoucherUserLimit",
    VOUCHER_OUT_OF_CODES = "VoucherOutOfCodes",
}

export enum ItemStatus {
    UNKNOWN = "unknown",
    DROPPED = "dropped",
    CLAIMED = "claimed",
    ALLOCATED = "allocated",
    REDEEMED = "redeemed",
    EXPIRED = "expired",
    NOPRIZE = "no-prize",
    PENDING = "pending",
}

export class VItem {
    id: string;
    campaignId: string;
    segmentId: string;
    categoryId: string;
    dropPoolId: string;
    walletId: string;
    merchantWalletId: string;
    prizeId: string;
    prizeStatus: PrizeStatus;
    voucherCode: string;
    voucherCodeId: string;
    latitude: number;
    longitude: number;
    loyaltyId: string | null;
    itemStatus: ItemStatus;
    dropDate: string;
    claimDate: string | null;
    redeemDate: string | null;
    allocatedAt: string;
    winning: boolean;
    shareStatus: ShareStatus;
    shareId: string;
    createdAt: string;
    updatedAt: string;
    // Category Details
    type: CategoryType;
    marker: string;
    asset: string;
    categoryConfig: LoyaltyConfig | null;
    loyaltyState: LoyaltyState | null;
    error?: string;
    // local state
    isDeepLink: boolean;
    // QR Code
    qrCodeUrl: string;
    qrActionId: string;
    skipToGameplay: boolean;

    constructor(data: Partial<VItem>) {
        this.id = data.id || "";
        this.campaignId = data.campaignId || "";
        this.segmentId = data.segmentId || "";
        this.categoryId = data.categoryId || "";
        this.dropPoolId = data.dropPoolId || "";
        this.walletId = data.walletId || "";
        this.merchantWalletId = data.merchantWalletId || "";
        this.prizeId = data.prizeId || "";
        this.prizeStatus = data.prizeStatus || PrizeStatus.UNALLOCATED;
        this.voucherCode = data.voucherCode || "";
        this.voucherCodeId = data.voucherCodeId || "";
        this.latitude = data.latitude || 0;
        this.longitude = data.longitude || 0;
        this.loyaltyId = data.loyaltyId || null;
        this.itemStatus = data.itemStatus || ItemStatus.UNKNOWN;
        this.dropDate = data.dropDate || "";
        this.claimDate = data.claimDate || null;
        this.redeemDate = data.redeemDate || null;
        this.allocatedAt = data.allocatedAt || "";
        this.winning = data.winning || false;
        this.shareStatus = data.shareStatus || ShareStatus.NOT_SHARED;
        this.shareId = data.shareId || "";
        this.createdAt = data.createdAt || "";
        this.updatedAt = data.updatedAt || "";
        this.type = data.type || CategoryType.STANDARD;
        this.marker = data.marker || "";
        this.asset = data.asset || "";
        this.categoryConfig = data.categoryConfig || null;
        this.loyaltyState = data.loyaltyState || null;
        this.error = data.error || undefined;
        this.skipToGameplay = data.skipToGameplay || false;
        // QR Code
        this.qrCodeUrl = data.qrCodeUrl || "";
        this.qrActionId = data.qrActionId || "";
        // local state
        if (deepLinkStore().deepLink?.vitemID == this.id) {
            this.isDeepLink = true;
        } else {
            this.isDeepLink = false;
        }
    }

    static fromJSON(json: Record<string, any>): VItem {
        return new VItem(json);
    }

    static fromJSONArray(jsonArray: any[]): VItem[] {
        return jsonArray.map((json) => VItem.fromJSON(json));
    }

    updateFromJSON(json: Record<string, any>): void {
        Object.assign(this, VItem.fromJSON(json));
    }
}

export interface LoyaltyConfig {
    enabled: boolean;
    prepopulated: boolean;
    repeatable: boolean;
    repeatableTimes: number;
    initLoyaltyVATText: string;
    initLoyaltyFaceCardText: string;
    endLoyaltyVATText: string;
    endLoyaltyFaceCardText: string;
    loyaltyVATImage: string;
    loyaltyOnRedeem: boolean;
    onRedeem: boolean;
    showLoyaltyVATAtStart: boolean;
    showCollectedVATs: boolean;
    hideLoyaltyVATAtEnd: boolean;
    hideCollectedVATsAtEnd: boolean;
    steps: LoyaltyStep[];
    total: number;
    iterate: number;
}

export interface LoyaltyStep {
    name: string;
    collectableCategoryID: string;
    rewardCategoryID: string;
    rewardPrizeID: string;
    loyaltyVATImage: string;
    loyaltyVATText: string;
    loyaltyFaceCardText: string;
}

export interface LoyaltyState {
    complete: boolean;
    collected: number;
    collectedList: string[];
    unCollectedList: string[];
    total: number;
    initText: string;
    image: string;
}
